import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  TextInput,
  FlatList,
} from "react-native";
import { useRecoilValue } from "recoil";
import { useIsFocused } from "@react-navigation/native";
import Modal from "modal-react-native-web";
const { tokenState, userState } = require("../reducer/recoil");
const { width, height } = Dimensions.get("window");
import { getAthletes } from "../action/authAction";
import { styles, stylesResponsive } from "./style/flatlistAthlete";
import { apiservice } from "../service";
export default function flatlistAthlete({ text, fil, gender }) {
  const [country, setCountry] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleMobile, setModalVisibleMobile] = useState(false);
  const token = useRecoilValue(tokenState);
  const profile = useRecoilValue(userState);
  const isFocus = useIsFocused();
  const [data, setData] = useState([]);
  const [dataRecord, setDataRecord] = useState([]);

  console.log("dataRecord", dataRecord);

  useEffect(() => {
    // callAll()
    callApi();
  }, [isFocus, token]);

  async function callApi() {
    const response = await getAthletes(token.token);
    if (response) {
      try {
        setData(
          response.getAllAthletes.filter(
            (item) =>
              item.association_id == profile.profile.Association.association_id
          )
        );
      } catch (error) {
        setData(response.getAllAthletes);
      }
    }
  }

  return (
    <View>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View>
          <TouchableOpacity
            onPress={() => setModalVisible(!modalVisible)}
            style={{
              width: width,
              height: height,
              backgroundColor: "#000000bb",
            }}
          ></TouchableOpacity>
          <View style={styles.viewRecordModal}>
            <Text style={styles.textNameRecordModal}>
              BEST RECORD : MEENA YOUDEE
            </Text>
            <View style={styles.viewTopicRecordModal}>
              <Text
                style={
                  width < 1600
                    ? styles.textTopicModalRespons
                    : styles.textTopicModal
                }
              >
                EVENTS
              </Text>
              <Text
                style={
                  width < 1600
                    ? styles.textTopicModalRespons
                    : styles.textTopicModal
                }
              >
                {"PESONAL BEST\nSTATISTIC"}
              </Text>
              <Text
                style={
                  width < 1600
                    ? styles.textTopicModalRespons
                    : styles.textTopicModal
                }
              >
                {"PESONAL BEST\nDATE"}
              </Text>
              <Text
                style={
                  width < 1600
                    ? styles.textTopicModalRespons
                    : styles.textTopicModal
                }
              >
                {"PESONAL BEST\nVENUE"}
              </Text>
              <Text
                style={
                  width < 1600
                    ? styles.textTopicModalRespons
                    : styles.textTopicModal
                }
              >
                {"SEASON BEST\nSTATISTIC"}
              </Text>
              <Text
                style={
                  width < 1600
                    ? styles.textTopicModalRespons
                    : styles.textTopicModal
                }
              >
                {"SEASON BEST\nDATE"}
              </Text>
              <Text
                style={
                  width < 1600
                    ? styles.textTopicModalRespons
                    : styles.textTopicModal
                }
              >
                {"SEASON BEST\nVENUE"}
              </Text>
            </View>
            <View style={{ paddingBottom: 47, paddingHorizontal: 10 }}>
              <FlatList
                data={dataRecord}
                scrollEnabled={false}
                renderItem={({ index, item }) => {
                  return (
                    <View style={styles.viewDetailModal}>
                      <Text style={[styles.textDetailModal]}>{item.event}</Text>
                      <Text style={[styles.textDetailModal]}>
                        {item.personal_best_stat}
                      </Text>
                      <Text style={[styles.textDetailModal]}>
                        {item.personal_best_date}
                      </Text>
                      <Text style={[styles.textDetailModal]}>
                        {item.personal_best_venue}
                      </Text>
                      <Text style={[styles.textDetailModal]}>
                        {item.season_best_stat}
                      </Text>
                      <Text style={[styles.textDetailModal]}>
                        {item.season_best_date}
                      </Text>
                      <Text style={[styles.textDetailModal]}>
                        {item.season_best_venue}
                      </Text>
                    </View>
                  );
                }}
              />
            </View>
          </View>
        </View>
      </Modal>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisibleMobile}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalVisibleMobile(!modalVisibleMobile);
        }}
      >
        <View>
          <TouchableOpacity
            onPress={() => setModalVisibleMobile(!modalVisibleMobile)}
            style={{
              width: width,
              height: height,
              backgroundColor: "#000000bb",
            }}
          ></TouchableOpacity>
          <View style={stylesResponsive.viewRecordModal}>
            <Text style={stylesResponsive.textNameRecordModal}>
              BEST RECORD : MEENA YOUDEE
            </Text>
            <View style={{ flexDirection: "row" }}>
              <View style={{ width: width * 0.3 }}>
                <View style={stylesResponsive.viewTopicModal}>
                  <Text style={stylesResponsive.textTopicModal}>{"EVENT"}</Text>
                </View>
                <View style={stylesResponsive.viewTopicModal}>
                  <Text style={stylesResponsive.textTopicModal}>
                    {"PESONAL BEST\nSTATISTIC"}
                  </Text>
                </View>
                <View style={stylesResponsive.viewTopicModal}>
                  <Text style={stylesResponsive.textTopicModal}>
                    {"PESONAL BEST\nDATE"}
                  </Text>
                </View>
                <View style={stylesResponsive.viewTopicModal}>
                  <Text style={stylesResponsive.textTopicModal}>
                    {"PESONAL BEST\nVENUE"}
                  </Text>
                </View>
                <View style={stylesResponsive.viewTopicModal}>
                  <Text style={stylesResponsive.textTopicModal}>
                    {"SEASON BEST\nSTATISTIC"}
                  </Text>
                </View>
                <View style={stylesResponsive.viewTopicModal}>
                  <Text style={stylesResponsive.textTopicModal}>
                    {"SEASON BEST\nDATE"}
                  </Text>
                </View>
                <View style={stylesResponsive.viewTopicModal}>
                  <Text style={stylesResponsive.textTopicModal}>
                    {"SEASON BEST\nVENUE"}
                  </Text>
                </View>
              </View>
              <View style={{ width: width * 0.6 }}>
                <FlatList
                  data={dataRecord}
                  horizontal
                  renderItem={({ index, item }) => {
                    return (
                      <View>
                        <View style={stylesResponsive.viewDetailModal}>
                          <Text style={[stylesResponsive.textDetailModal]}>
                            {item.event}
                          </Text>
                        </View>
                        <View style={stylesResponsive.viewDetailModal}>
                          <Text style={[stylesResponsive.textDetailModal]}>
                            {item.personal_best_stat}
                          </Text>
                        </View>
                        <View style={stylesResponsive.viewDetailModal}>
                          <Text style={[stylesResponsive.textDetailModal]}>
                            {item.personal_best_date}
                          </Text>
                        </View>
                        <View style={stylesResponsive.viewDetailModal}>
                          <Text style={[stylesResponsive.textDetailModal]}>
                            {item.personal_best_venue}
                          </Text>
                        </View>
                        <View style={stylesResponsive.viewDetailModal}>
                          <Text style={[stylesResponsive.textDetailModal]}>
                            {item.season_best_stat}
                          </Text>
                        </View>
                        <View style={stylesResponsive.viewDetailModal}>
                          <Text style={[stylesResponsive.textDetailModal]}>
                            {item.season_best_date}
                          </Text>
                        </View>
                        <View style={stylesResponsive.viewDetailModal}>
                          <Text style={[stylesResponsive.textDetailModal]}>
                            {item.season_best_venue}
                          </Text>
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </View>
          </View>
        </View>
      </Modal>
      {width >= 1280 && (
        <View style={[styles.viewTopic]}>
          <Text
            numberOfLines={1}
            style={[
              width < 1600 ? styles.textTitleRespons : styles.textTitle,
              { width: "100%", maxWidth: 120 },
            ]}
          >
            {"IMAGE"}
          </Text>
          <Text
            numberOfLines={1}
            style={[
              width < 1600 ? styles.textTitleRespons : styles.textTitle,
              { width: "15%" },
            ]}
          >
            {"FIRST NAME"}
          </Text>
          <Text
            numberOfLines={1}
            style={[
              width < 1600 ? styles.textTitleRespons : styles.textTitle,
              { width: "15%" },
            ]}
          >
            {"LAST NAME"}
          </Text>
          <Text
            numberOfLines={1}
            style={[width < 1600 ? styles.textTitleRespons : styles.textTitle]}
          >
            {"GENDER"}
          </Text>
          <Text
            numberOfLines={1}
            style={[width < 1600 ? styles.textTitleRespons : styles.textTitle]}
          >
            {"BIRTH"}
          </Text>
          <Text
            numberOfLines={1}
            style={[width < 1600 ? styles.textTitleRespons : styles.textTitle]}
          >
            {"COUNTRY"}
          </Text>
          <Text style={{ width: "20%", marginLeft: 20 }}></Text>
        </View>
      )}
      <FlatList
        data={data
          .filter((item) =>
            item.first_name.toLowerCase().includes(text.toLowerCase())
          )
          .filter((item) =>
            item.Country.country_name.toLowerCase().includes(fil.toLowerCase())
          )
          .filter((item) => {
            if (item.gender != null) {
              return item.gender.includes(gender);
            }
          })
          .filter((item) => {
            try {
              return profile.profile.Association
                ? item.association_id ==
                    profile.profile.Association.association_id
                : true;
            } catch (error) {
              return true;
            }
          })}
        scrollEnabled={false}
        renderItem={({ index, item }) => {
          console.log(index, item);
          return width >= 1280 ? (
            <View
              style={[
                styles.viewDetail,
                {
                  backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                  borderTopWidth: index >= 1 ? 0 : 1,
                },
              ]}
            >
              <Image
                resizeMode={"contain"}
                style={styles.imgDetail}
                source={{ uri: item.image_url }}
              />

              <Text
                numberOfLines={1}
                style={[styles.textDetail, { width: "15%" }]}
              >
                {item.first_name}
              </Text>
              <Text
                numberOfLines={1}
                style={[styles.textDetail, { width: "15%" }]}
              >
                {item.last_name}
              </Text>
              <Text
                numberOfLines={1}
                style={[styles.textDetail, { width: "10%" }]}
              >
                {item.gender}
              </Text>
              <Text
                numberOfLines={1}
                style={[styles.textDetail, { width: "10%" }]}
              >
                {item.birth_date.toString().split("T")[0]}
              </Text>
              <Text
                numberOfLines={1}
                style={[styles.textDetail, { width: "10%" }]}
              >
                {item.Country.country_name}
              </Text>

              <TouchableOpacity
                style={styles.buttonRecords}
                onPress={async () => {
                  let association_id = null;
                  try {
                    association_id = profile.profile.Association.association_id;
                  } catch (error) {
                    association_id = item.association_id;
                  }

                  const resonse = await apiservice({
                    path:
                      "/athletes/detail/" +
                      item.passport +
                      "?association_id=" +
                      association_id,
                    method: "get",
                    token: token.token,
                  });

                  let best = [];

                  resonse.data.result.map((i) => {
                    best = best.concat(i.best_record);
                  });

                  setDataRecord(best);
                  setTimeout(() => {
                    setModalVisible(true);
                  }, 300);
                }}
              >
                <Text style={styles.textRecords}>BEST RECORDS</Text>
              </TouchableOpacity>
            </View>
          ) : (
            <View
              style={[
                styles.viewDetail,
                {
                  backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                  borderTopWidth: index >= 1 ? 0 : 1,
                },
              ]}
            >
              <Image
                resizeMode={"contain"}
                style={styles.imgDetail}
                source={{ uri: item.image_url }}
              />
              <View>
                <View
                  style={{
                    flexDirection: "row",
                    width: width * 0.3,
                    justifyContent: "space-between",
                  }}
                >
                  <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                    {item.first_name}
                  </Text>

                  <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                    {item.last_name}
                  </Text>
                </View>
                <View>
                  <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                    {item.gender}
                  </Text>
                  <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                    {item.birth_date.toString().split("T")[0]}
                  </Text>
                  <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                    {item.Country.country_name}
                  </Text>
                </View>
              </View>
              <TouchableOpacity
                style={stylesResponsive.buttonRecords}
                // onPress={() => {

                //   setDataRecord(item.best_record);
                //   setModalVisibleMobile(true);
                // }}
                onPress={async () => {
                  let association_id = null;
                  try {
                    association_id = profile.profile.Association.association_id;
                  } catch (error) {
                    association_id = item.association_id;
                  }

                  const resonse = await apiservice({
                    path:
                      "/athletes/detail/" +
                      item.passport +
                      "?association_id=" +
                      association_id,
                    method: "get",
                    token: token.token,
                  });

                  let best = [];

                  resonse.data.result.map((i) => {
                    best = best.concat(i.best_record);
                  });

                  setDataRecord(best);
                  setTimeout(() => {
                    setModalVisibleMobile(true);
                  }, 300);
                }}
              >
                <Text style={stylesResponsive.textRecords}>BEST RECORDS</Text>
              </TouchableOpacity>
            </View>
          );
        }}
      />
    </View>
  );
}
